import { getTravleBanner } from '@/axios/api'

const travleBanner = {
  state: {
    travleBanner: []
  },
  mutations: {
    SET_TRAVLEBANNER (state, travleBanner) {
      state.travleBanner = travleBanner
    },
    SET_TRAVLEBANNERsMALL (state, travleBannerSmall) {
      state.travleBannerSmall = travleBannerSmall
    }
  },
  actions: {
    TRAVLEBANNER ({ commit }, params) {
      getTravleBanner(params).then(res => {
        this.state.travleBanner = res.data.data
      })
    }
  }
}

export default travleBanner



// WEBPACK FOOTER //
// ./src/store/modules/getTravleBanner.js